import { COLUMN_NOWRAP_WITH_TOOLTIP } from 'domain/consts';
import {
  ADEBIFY_DIMENSION_TOOLTIP_FIELDS,
  ADEBIFY_LEGACY_CELL_FIELD_KEYS,
} from './tableDimensionFields';

const ADEBIFY_TOOLTIP_FIELD_SET = new Set([
  ...ADEBIFY_DIMENSION_TOOLTIP_FIELDS,
  ...ADEBIFY_LEGACY_CELL_FIELD_KEYS,
]);

/**
 * True when a table column should ellipsis-overflow and show full text on hover.
 * Extends legacy detail-analysis COLUMN_NOWRAP_WITH_TOOLTIP for adebify keys.
 */
const hasTableCellTooltip = (metric) =>
  COLUMN_NOWRAP_WITH_TOOLTIP.includes(metric) ||
  ADEBIFY_TOOLTIP_FIELD_SET.has(metric);

export default hasTableCellTooltip;
